import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { HIERARCHY_API } from "./apiRoutes";

interface UseGetDistributionRuleProps {
  communityId: string;
  level: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionRuleHierarchy = async (communityId: string, level: string) =>
  await axiosAuth.get(`${HIERARCHY_API}/${communityId}/hierarchy?level=${level}`);

const useGetDistributionRuleHierarchy = ({
  queryParams,
  communityId,
  level
}: UseGetDistributionRuleProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-rule-hierarchy", communityId, level],
    queryFn: () => getDistributionRuleHierarchy(communityId, level),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDistributionRuleHierarchy;
